import { SalaryElement } from '@pflegia/types/api/job-position/salary-element';

import { Emoji } from '../emoji/Emoji';

interface SalaryDetailItemProps {
  bonusElements: SalaryElement[];
  title: string;
}

export const SalaryDetailItem: React.FC<SalaryDetailItemProps> = ({ bonusElements, title }) => (
  <div className='my-4 md:my-6'>
    <div className='text-main-blue text-lg font-medium'>
      <Emoji text={title} />
    </div>
    {bonusElements.map(bonusElement => (
      <div className='mt-4 flex' key={bonusElement.title}>
        <p className='text-default text-sm font-normal'>{bonusElement.title}</p>
        <p className='text-default ml-auto text-sm'>
          {bonusElement.value.toLocaleString('de', { maximumFractionDigits: 2 })}€<sup>*</sup>
        </p>
      </div>
    ))}
  </div>
);

export default SalaryDetailItem;
